import React from 'react';
import { SaveOutlined } from '@ant-design/icons';
import { Row, Col, Space, Button } from 'antd';
import company from '../../../assets/icons/company/01.svg';

export default function Header(props) {
    return (
        <Row wrap={true} className='mb-30'>
            <Col flex="auto">
                <div className='vertical-center'>
                    <Space wrap>
                        <img src={company} height={24} alt="img" className='align-middle' />
                        <span className='title-page'>Mi Empresa</span>
                    </Space>
                </div>
            </Col>
            <Col flex="none">
                <Space wrap>
                    <Button
                        type='primary'
                        shape='round'
                        icon={<SaveOutlined />}
                        onClick={props.onSave}
                    >
                        Guardar
                    </Button>
                </Space>
            </Col>
        </Row>
    )
}